module.exports = __webpack_public_path__ + "img/templa_b.a4480201.png";